import { inject, Service } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EventBusService } from '@shared';
import { map, Observable } from 'rxjs';
import { DEFAULT_HEADER_CONFIGURATION, HEADER_EVENTS, HeaderConfigurationEvent } from './header-events.model';

/**
 * App Header Event Consumer
 *
 * Consumes configuration events from feature modules to update header appearance.
 */
@Service()
export class HeaderEventConsumerService {
	private readonly eventBus = inject(EventBusService);

	readonly configuration$: Observable<Required<HeaderConfigurationEvent>> = this.eventBus
		.on$<HeaderConfigurationEvent>(HEADER_EVENTS.CONFIGURATION)
		.pipe(map(wrapped => ({ ...DEFAULT_HEADER_CONFIGURATION, ...wrapped?.data })));

	readonly configuration = toSignal(this.configuration$, {
		initialValue: DEFAULT_HEADER_CONFIGURATION
	});
}
